import {Place} from './place';

export class User {
	public id: number;
	public name: string;
	public surname: string;
	public email: string;
	public cod_fiscale: string;
	public is_admin: boolean;
	public is_superadmin: boolean;
	public sex: string;
	public birthplace: Place;
	public residence: Place;
	public prefix: string;

	constructor(server_obj) {
		this.prefix = 'usr_';
		if (server_obj) {
			this.id = Number(server_obj[this.prefix + 'id']);
			this.name = server_obj[this.prefix + 'name'];
			this.surname = server_obj[this.prefix + 'surname'];
			this.email = server_obj[this.prefix + 'email'];
			this.cod_fiscale = server_obj[this.prefix + 'cod_fiscale'];
			this.sex = server_obj[this.prefix + 'sex'];
			this.is_admin = server_obj[this.prefix + 'is_admin'] === 1;
			this.is_superadmin = server_obj[this.prefix + 'is_superadmin'] === 1;
			this.sex = server_obj[this.prefix + 'sex'];

			// this.birthplace = new Place(server_obj);
			this.residence = new Place(server_obj);
		} else {
			// this.birthplace = new Place(undefined);
			this.residence = new Place(undefined);
		}

	}
}
